export function popUp(){
  const modal = document.querySelector('.pop-up');

  if(modal){
    let flagToDisplay = true;
    if( modal.getAttribute('data-autoOpen') &&  modal.getAttribute('data-openDelay') ){
      
      if(modal.getAttribute('data-tealium-based-show') == 'yes'){
          flagToDisplay = false;
          setTimeout(function(){
            const validValues = modal.getAttribute('data-tealium-match');
            const operator = modal.getAttribute('data-tealium-operator');
            const tealVar = modal.getAttribute('data-tealium-path');
            
            const keys = tealVar.split('.');
            let utagRef = window;

            let exists = true;
            const getObjRouteValue = getNestedValue(utagRef,tealVar);
            if(getObjRouteValue === 'undefinded'){
              return;
            }

            if( utagRef && ( tealVar != '' ) ){
              if( operator === 'equals' ){
                if( getObjRouteValue == validValues ){
                  flagToDisplay = true;
                }
              }
              if( operator === 'contains' ){
                if( validValues.includes(getObjRouteValue) ){
                  flagToDisplay = true;
                }
              }
              
            }

            if(flagToDisplay){
              console.log(utagRef);
              if(modal.getAttribute('data-openDelay') !== 0){
                setTimeout(function(){
                  modal.classList.toggle('open');
                  if(document.querySelector('.custom-pop-up-trigger')){
                    document.querySelector('.custom-pop-up-trigger').style.display = 'none';
                  }
                },modal.getAttribute('data-openDelay') * 1000);
      
              } else{
                if(document.querySelector('.custom-pop-up-trigger')){
                  document.querySelector('.custom-pop-up-trigger').style.display = 'none';
                }
                modal.classList.toggle('open');
              }
            } else{
              modal.style.display = 'none';
              document.querySelector('.custom-pop-up-trigger').style.display = 'none';
            }
            if(modal.getAttribute('data-classSelector') && flagToDisplay ){
              if(document.querySelectorAll(`.${modal.getAttribute('data-classSelector')}`)){
                document.querySelectorAll(`.${modal.getAttribute('data-classSelector')}`).forEach((elem) => {
                  elem.addEventListener('click',() => {
                    modal.classList.toggle('open');
                    if(document.querySelector('.custom-pop-up-trigger')){
                      document.querySelector('.custom-pop-up-trigger').style.display = 'none';
                    }
                  })
                });
              }
            }
          },1000)
      } else{

        if(modal.getAttribute('data-openDelay') !== 0){

          setTimeout(function(){
            modal.classList.toggle('open');
            if(document.querySelector('.custom-pop-up-trigger')){
              document.querySelector('.custom-pop-up-trigger').style.display = 'none';
            }
          },modal.getAttribute('data-openDelay') * 1000);

        } else{

          if(document.querySelector('.custom-pop-up-trigger')){
            document.querySelector('.custom-pop-up-trigger').style.display = 'none';
          }
          modal.classList.toggle('open');

        }
      }

    } 

    if(modal.getAttribute('data-maxWidthDesk')){
      modal.style.setProperty('--maxWidthDesk', `${modal.getAttribute('data-maxWidthDesk')}`);
    }
    if(modal.getAttribute('data-maxWidthMobile')){
      modal.style.setProperty('--maxWidthMobile', `${modal.getAttribute('data-maxWidthMobile')}`);
    }
  
    modal.querySelector('.close').addEventListener('click', () => {
      modal.classList.toggle('open');
      if(document.querySelector('.custom-pop-up-trigger')){
        document.querySelector('.custom-pop-up-trigger').style.display = 'block';
      }
      const onCloseEvent = new Event('ocwModalClosed');
      modal.dispatchEvent(onCloseEvent);
    });

    if(modal.getAttribute('data-classSelector') && flagToDisplay ){
      if(document.querySelectorAll(`.${modal.getAttribute('data-classSelector')}`)){
        document.querySelectorAll(`.${modal.getAttribute('data-classSelector')}`).forEach((elem) => {
          elem.addEventListener('click',() => {
            modal.classList.toggle('open');
            if(document.querySelector('.custom-pop-up-trigger')){
              document.querySelector('.custom-pop-up-trigger').style.display = 'none';
            }
          })
        });
      }
    }

    if(document.querySelector('.custom-pop-up-trigger')){
      const oprtMenu = document.querySelector('.ocw-navbar');

      let marginLeft = parseInt(window.getComputedStyle(oprtMenu).marginLeft);
      let marginRight = parseInt(window.getComputedStyle(oprtMenu).marginRight);
      document.querySelector('.custom-pop-up-trigger').style.setProperty('--leftSpacing', `${marginLeft}px`);
      document.querySelector('.custom-pop-up-trigger').style.setProperty('--rightSpacing', `${marginRight}px`);
      window.addEventListener('resize', () => {
        const oprtMenu = document.querySelector('.ocw-navbar');
        marginLeft = parseInt(window.getComputedStyle(oprtMenu).marginLeft);
        marginRight = parseInt(window.getComputedStyle(oprtMenu).marginRight);
        document.querySelector('.custom-pop-up-trigger').style.setProperty('--leftSpacing', `${marginLeft}px`);
        document.querySelector('.custom-pop-up-trigger').style.setProperty('--rightSpacing', `${marginRight}px`);
      });
    }
  }
}


function getNestedValue(obj, path) {
  const pathParts = path.split(/[\.\[\]\'\"]/).filter(Boolean); // Split the route in parts excluding the  [ ] ' " 

  return pathParts.reduce((acc, part) => {
      if (acc !== undefined && acc !== null) {
          return acc[part]; // Accessing the prop of the obj
      }
      return undefined; // If can not access to the obj because doesn't exist, return "undefinded" 
  }, obj);
}
